<template>
  <v-container fill-height class="my-5">
    <v-layout>
      <v-flex xs12>
        <v-card outlined>
          <v-card-title>
            <v-icon
              medium
              left>
              insert_chart
            </v-icon>
            <span class="title">Dashboard</span>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="4">
                <v-card
                  outlined>
                  <v-card-text>
                    <alertsp :alertdata="alertdata"></alertsp>
                    <v-select
                      :items="listyears"
                      name="filteryear"
                      v-model="filter.year"
                      label="Year">
                    </v-select>
                    <v-btn
                      :loading="loading.changedb"
                      :disabled="loading.changedb"
                      block
                      :color="maincolor"
                      class="white--text"
                      @click="updateChart">
                      Change
                    </v-btn>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" md="4">
                <v-card
                  class="mx-auto text-center"
                  color="blue"
                  dark>
                  <v-card-text>
                    <v-icon size="50" dark>mdi-briefcase-account</v-icon>
                  </v-card-text>
                  <v-card-text>
                    <div class="display-1">
                      {{ datacard.jobvacancy }}
                    </div>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions class="justify-center">
                    <v-btn
                      block
                      text
                      :to="{ name: 'JobsCompany', query: { valid: 'yes' } }">
                      Job vacancy <v-icon right>arrow_forward</v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
              <v-col cols="12" md="4">
                <v-card
                  class="mx-auto text-center"
                  color="red"
                  dark>
                  <v-card-text>
                    <v-icon size="50" dark>mdi-account-tie</v-icon>
                  </v-card-text>
                  <v-card-text>
                    <div class="display-1">
                      {{ datacard.jobapply }}
                    </div>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions class="justify-center">
                    <v-btn
                      block
                      text
                      :to="{ name: 'ProfileCompany', query: { tab: 'jobs' } }">
                      Job applicant <v-icon right>arrow_forward</v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from 'vuex';
import Alertsp from '../../components/Alert.vue';

export default {
  name: 'DashboardCom',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    api: process.env.VUE_APP_API,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    loading: {
      changedb: false,
    },
    filter: {
      year: new Date().getFullYear(),
    },
    datacard: {
      jobvacancy: 0,
      jobapply: 0,
    },
  }),
  created: () => ({
  }),
  mounted() {
    // init request
    if (this.tokenscr) {
      this.updateChart();
    }
  },
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
      'userbanjar',
    ]),
    listyears() {
      const year = new Date().getFullYear();
      const lyear = Array.from({length: year - 2017}, (value, index) => 2018 + index);
      lyear.push('all');
      return lyear;
    },
  },
  methods: {
    resetDataCard() {
      this.datacard = {
        jobvacancy: 0,
        jobapply: 0,
      };
    },
    updateChart() {
      this.resetDataCard();
      if (this.tokenscr) {
        this.loading.changedb = true;
        this.alertdata.show = false;
        this.axios
          .get(
            this.api + '/api/company/dashboard/' + this.filter.year,
            {
              params: {},
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                this.datacard = resdata.data;
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = resdata.message;
              }
            } else {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
            }
            this.loading.changedb = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.changedb = false;
            this.alertdata.show = true;
            this.alertdata.type = 'error';
            this.alertdata.text = 'Internal services error!';
          });
      }
    },
  },
  components: {
    Alertsp,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
